
import React, { useEffect, useState, useMemo } from 'react';
import { Card, CardBody, HeaderTitle, MenuSVG, Table } from '../../../../components';
import { useExpirationsContext } from '../context/ExpirationsUIContext';
import { UIHelpers } from '../../../../constants/pages/UIHelpers';
import SummariesColumns from './ExpirationsColumns';
import { usersService } from '../../../../services';
import page from '../../../../constants/pages/page';
import { Box, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useParams, useHistory } from 'react-router-dom';
import { WidgetSecondaryData } from '../../../../components/widget/WidgetSecondaryData';
import { WidgetPrimaryData } from '../../../../components/widget/WidgetPrimaryData';
import { WidgetPrice } from '../../../../components/widget/WidgetPrice';
import EXPIRATIONS_CLOSING_GROUPS from '../../../../constants/expirationgroups/groups';
import { palette } from '../../../../styles/theme';

const detailsTitleStyles = { fontWeight: '600', fontSize: '18px', color: palette.disabled[950], lineHeight: '24px', letterSpacing: '0.216px', fontFamily: 'Roboto' };
const detailsTotalsStyles = { fontWeight: '600', fontSize: '12px', color: palette.disabled.main, lineHeight: 'normal', fontFamily: 'Roboto' };
const detailsContentStyles = { color: palette.secondary[600], fontSize: '18px', fontWeight: '600', lineHeight: '24px', letterSpacing: '0.216px', fontFamily: 'Roboto' };

export default function ExpirationsTable () {
    const { t } = useTranslation();
    const { defaultSorted } = UIHelpers();
    const { id } = useParams();
    const expirationsRoute = '/cards/expirations';
    const history = useHistory();
    const isClosingGroupIdValid = EXPIRATIONS_CLOSING_GROUPS[id];
    const [expirations, setExpirations] = useState({});
    // Context state
    const expirationsUIContext = useExpirationsContext();
    const expirationsUIProps = useMemo(() => {
        return {
            isLoading: expirationsUIContext.isLoading,
            setIsLoading: expirationsUIContext.setIsLoading,
            queryParams: expirationsUIContext.queryParams,
            setQueryParams: expirationsUIContext.setQueryParams
        };
    }, [expirationsUIContext]);

    // Functions
    async function fetchExpirations () {
        // change state isLoading
        expirationsUIProps.setIsLoading(true);
        const { sortField, sortOrder } = expirationsUIProps.queryParams;
        // Prepare options (order, pages)
        const options = {
            order: `${sortField}-${sortOrder.toUpperCase()}`,
            pageSize: expirationsUIProps.queryParams.pageSize,
            page: expirationsUIProps.queryParams.pageNumber,
            filters: `closing_group eq ${id}`
        };

        await usersService.getExpirations(options)
            .then(expirations => {
                setExpirations(expirations);
            })
            .catch(e => {
                console.error(e);
                return [];
            })
            .finally(() => {
                expirationsUIProps.setIsLoading(false);
            });
    };

    useEffect(() => {
        expirationsUIProps.setQueryParams(prev => ({ ...prev, pageSize: localStorage.getItem('sizePerPage') || page.pageSize }));
        if (!isClosingGroupIdValid) history.push(`${expirationsRoute}/${53}`);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (JSON.stringify(expirationsUIProps.queryParams) !== undefined && isClosingGroupIdValid) {
            fetchExpirations();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [expirationsUIProps.queryParams, id]);

    // Main Component
    return (
        <Card>
            <Box>
                <HeaderTitle
                    title={t('expirations.table.title')}
                    reset={false}
                    icon={<MenuSVG className='mr-1' />}
                    UIProps={expirationsUIProps}
                />
            </Box>
            <CardBody>
                <Stack direction={'row'} alignItems={'center'} justifyContent={'flex-start'} marginBottom='20px' >
                    <WidgetPrimaryData title={'Grupo de cierre'} value={id} titleStyles={detailsTitleStyles} valueStyles={detailsContentStyles}/>
                    <WidgetSecondaryData title={t('expirations.table.details.cards')} value={expirationsUIProps.isLoading || !expirations.totalCards ? '-' : expirations.totalCards} titleStyles={detailsTotalsStyles} valueStyles={detailsContentStyles}/>
                    <WidgetSecondaryData title={t('expirations.table.details.totalBalance')} value={expirationsUIProps.isLoading ? '-' : <WidgetPrice width='135px' textAlign={'center'} number = {expirations.totalPayments}/>} titleStyles={detailsTotalsStyles} valueStyles={detailsContentStyles}/>
                    <WidgetSecondaryData title={t('expirations.table.details.closingDate')} value={expirationsUIProps.isLoading || !expirations.closingDate ? '-' : expirations.closingDate.replace(/-/g, '/') } titleStyles={detailsTotalsStyles} valueStyles={detailsContentStyles}/>
                    <WidgetSecondaryData title={t('expirations.table.details.expirationDate')} value={expirationsUIProps.isLoading || !expirations.dueDate ? '-' : expirations.dueDate.replace(/-/g, '/')} titleStyles={detailsTotalsStyles} valueStyles={detailsContentStyles}/>
                </Stack>
                <Table
                    data={expirations?.list}
                    columns={SummariesColumns({ expirations })}
                    total={expirations?.totalCards}
                    sort={defaultSorted}
                    onChange={expirationsUIProps.setQueryParams}
                    isLoading={expirationsUIProps.isLoading}
                    pagination={{
                        sizePerPage: expirationsUIProps.queryParams.pageSize,
                        page: expirationsUIProps.queryParams.pageNumber
                    }}
                />
            </CardBody>
        </Card>
    );
};
